export const CALLBACK_TIME_EXCEEDED = 'CALLBACK_TIME_EXCEEDED'
export const GET_EVENTS = 'GET_EVENTS'
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE'
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS'
export const GET_ODDS_LINES = 'GET_ODDS_LINES'
export const LAST_UPDATE_TIME = 'LAST_UPDATE_TIME'
export const LIVE_UPDATES = 'LIVE_UPDATES'
export const LIVE_LINES_UPDATES = 'LIVE_LINES_UPDATES'
export const REQUEST_CALLBACK = 'REQUEST_CALLBACK'
export const SCREEN_RESIZE = 'SCREEN_RESIZE'
export const UPDATE_MAX_SEQUENCES = 'UPDATE_MAX_SEQUENCES'
export const UPDATE_LINES = 'UPDATE_LINES'
export const UPDATE_LINES_SUCCESS = 'UPDATE_LINES_SUCCESS'
export const UPDATE_LINES_FAILURE = 'UPDATE_LINES_FAILURE'
export const CLEAN_EVENT_PLAYS = 'CLEAN_EVENT_PLAYS'
export const CLEAN_EVENTS = 'CLEAN_EVENTS'
export const GET_LINES = 'GET_LINES'
export const GET_LINES_SUCCESS = 'GET_LINES_SUCCESS'
export const FETCH_FUTURE_EVENT_INFO = 'FETCH_FUTURE_EVENT_INFO'
export const FETCH_FUTURE_EVENT_SUCCESS = 'FETCH_FUTURE_EVENT_SUCCESS'
export const FETCH_FUTURE_EVENT_FAILURE = 'FETCH_FUTURE_EVENT_FAILURE'
